import classNames from 'classnames';
import { useMemo } from 'react';
import { Button, Heading } from 'yoso';
import { AuthLink, AuthLinkProps } from '~/components/Auth/Link/AuthLink';
import { BaseCard } from '~/components/Card';
import { useEvolutions } from '~/components/Evolve/Evolve.hooks';
import heroStyles from '~/components/Hero/Hero.module.scss';
import { T } from '~/components/I18n';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import styles from './EvolveHero.module.scss';

export type EvolveHeroProps = {
  className?: string;
};

export const EvolveHero = ({ className }: EvolveHeroProps) => {
  const { data } = useEvolutions();
  const evolvableCount = useMemo(
    // NOTE: minNftAmount cannot be 0 or it's error
    () => data.getReady.reduce((acc, cur) => acc + Math.floor(cur.nftAmount / cur.minNftAmount), 0),
    [data.getReady]
  );

  return (
    <BaseCard className={classNames(heroStyles.root, styles.root, className)} size="large">
      <Heading level={3} className={heroStyles.heading}>
        <T name="citizen_evolve_title" />
      </Heading>
      <DescriptionList layout="responsive" className={heroStyles.sublist}>
        <dt>
          <T name="citizen_evolve_available_count_desc" />
        </dt>
        <dd>{evolvableCount}</dd>
      </DescriptionList>
      <Button<AuthLinkProps>
        as={AuthLink}
        to="#list"
        className={classNames(heroStyles.button, heroStyles.fixedButton)}
        size="large"
        data-event="click"
        data-event-target="evolve_top_gotolist_btn"
        replace>
        <T name="citizen_membership_evolve_title" />
      </Button>
    </BaseCard>
  );
};
